<script>
import PagenationContainer from "@/components/common/PagenationContainer.vue";
import visionChallengeChart from "@/components/patientManagement/visionChallengeChart.vue";
import moment from "moment";
const mapEyes = {
  finallyEyes: "双眼同时",
  finallyRight: "右眼",
  finallyLeft: "左眼"
};
export default {
  components: {
    PagenationContainer,
    visionChallengeChart
  },
  //   props: {
  //     purchaseHistorList: Array,
  //     sourceData: Object
  //   },
  data() {
    // const pageCount = this.sourceData.totalPages;
    // console.log("this.$route.params.patientId", this.$route.params.patientId);
    const patientId = this.$route.params.patientId;
    return {
      checkBoxSelect: true,
      closePayment: false,
      //   defaultValue: {},
      pageCount: undefined,
      patientId,
      activePage: 1,
      challengeResult: [],
      visionChallengeResult: [],
      dateRange: undefined,
      challengeType: "all",
      showResultTable: true,
      challengeTypeMap: {
        VISION_CHALLENGE: "视力",
        WORTH_FOUR_LAMP_HOLE_CHALLENGE: "Worth四孔灯",
        PERCEPTUAL_EYE_POSITION: "知觉眼位",
        LINE_FUSION: "线条融合",
        LINE_STEREOPSIS: "线条立体式",
        EXTENSIVENESS_STEREOPSIS: "大范围立体式",
        AMBLYOPIA_INHIBITION_EQUILIBRIUM_POINT: "弱视抑制平衡点",
        STRABISMUS_INHIBITION_EQUILIBRIUM_POINT: "斜视抑制平衡点",
        CONTRAST_SENSITIVITY_TRAINING: "对比敏感度"
      }
    };
  },
  created() {
    this.loadData();
    this.loadVisionData();
  },
  methods: {
    async loadData(date) {
      const activePage = this.activePage || 1;
      let params = {
        page: activePage - 1,
        size: 10,
        sort: "createdAt,DESC"
      };
      if (this.challengeType && this.challengeType !== "all") {
        params.type = this.challengeType;
      }
      let patientId = this.patientId;
      let data = await this.$http.getPatientVisionChallenge(patientId, params);
      this.pageCount = data.totalPages;
      this.challengeResult = data.content;
    },
    async loadVisionData(date) {
      let params = {
        type: "VISION_CHALLENGE"
      };

      let patientId = this.patientId;
      let data = await this.$http.getPatientVisionChallenge(patientId, params);

      this.visionChallengeResult = data.content;
    },
    pageClick(page) {
      this.encodeToUrl({
        page: page
      });
    },
    handleCurrentChange(val) {
      this.activePage = val;
      this.loadData();
    },
    challengeAtFormtter(row) {
      return moment(row.createdAt).format("YYYY-MM-DD HH:mm:ss");
    },
    challengeTypeFormtter(row) {
      if (this.challengeTypeMap[row.type]) {
        return this.challengeTypeMap[row.type];
      } else {
        return "--";
      }
    },
    challengeResultFormtter(row) {
      if (row.type === "VISION_CHALLENGE") {
        if (row.leftEyeVision || row.rightEyeVision) {
          return `右眼：${
            row.rightEyeVision ? row.rightEyeVision.toFixed(1) : "--"
          }  左眼：${row.leftEyeVision ? row.leftEyeVision.toFixed(1) : "--"}`;
        }
      } else if (row.type === "WORTH_FOUR_LAMP_HOLE_CHALLENGE") {
        return row.result.result;
      } else if (row.type === "PERCEPTUAL_EYE_POSITION") {
        const resultEyePosition =
          row.result && row.result.data ? row.result.data : row.result;
        return `算术平均：水平${resultEyePosition.jisuan.deviation_x}度，垂直${resultEyePosition.jisuan.deviation_y}度；绝对平均：水平${resultEyePosition.juedui.deviation_x}度，垂直${resultEyePosition.juedui.deviation_y}度`;
      } else if (row.type === "LINE_FUSION") {
        return `分开：${row.result.fenkai ||
          row.result.data.fenkai}度；辐辏：${row.result.fucou ||
          row.result.data.fucou}度`;
      } else if (row.type === "LINE_STEREOPSIS") {
        return row.result.result;
      } else if (row.type === "EXTENSIVENESS_STEREOPSIS") {
        return row.result.result;
      } else if (row.type === "AMBLYOPIA_INHIBITION_EQUILIBRIUM_POINT") {
        return `抑制值：${row.result.result || "--"}`;
      } else if (row.type === "STRABISMUS_INHIBITION_EQUILIBRIUM_POINT") {
        return `抑制值：${row.result.result || "--"}`;
      } else if (row.type === "CONTRAST_SENSITIVITY_TRAINING") {
        // console.log('>>>>>',row,row.result)
        const temp = row.result.data.map(o => {
          const tempName = mapEyes[o.type];
          const data = `(${o.data.map(arr => arr.join("：")).join("，")})`;
          return `${tempName}：${data}；`;
        });
        return `${temp.join("； ")}`;
        return "--";
      } else {
        return "--";
      }
    },
    onSelectChange(label) {
      this.challengeType = label;
      this.loadData();
    }
    // onClickSwitchView() {
    //   if (this.challengeType) this.;
    // }
  }
};
</script>

<template>
  <div class="AgentDetailVisionChallenge">
    <div class="TextGroup">
      <div class="typeSearch">
        <span>挑战类型：</span>
        <el-select v-model="challengeType" @change="onSelectChange">
          <el-option label="全部" value="all"></el-option>
          <el-option label="视力" value="VISION_CHALLENGE"></el-option>
          <el-option label="对比敏感度" value="CONTRAST_SENSITIVITY_TRAINING"></el-option>
          <el-option label="Worth四孔灯" value="WORTH_FOUR_LAMP_HOLE_CHALLENGE"></el-option>
          <el-option label="知觉眼位" value="PERCEPTUAL_EYE_POSITION"></el-option>
          <el-option label="线条融合" value="LINE_FUSION"></el-option>
          <el-option label="线条立体式" value="LINE_STEREOPSIS"></el-option>
          <el-option label="大范围立体式" value="EXTENSIVENESS_STEREOPSIS"></el-option>
          <el-option label="弱视抑制平衡点" value="AMBLYOPIA_INHIBITION_EQUILIBRIUM_POINT"></el-option>
          <el-option label="斜视抑制平衡点" value="STRABISMUS_INHIBITION_EQUILIBRIUM_POINT"></el-option>
        </el-select>
      </div>
      <div class="dateSearch">
        <span>切换视图：</span>
        <img
          class="switchIcon"
          src="@/assets/chart_switch_list.png"
          @click="showResultTable = !showResultTable"
        />
      </div>
    </div>
    <el-table
      :data="challengeResult"
      v-if="showResultTable"
      class="AgencyAccountTable"
      :header-cell-style="{ 'padding-left': '5px',color: 'rgba(0,0,0,0.65)','font-size': '14px', 'background-color': '#fafafa !important'}"
      :cell-style="{'padding-left': '5px'}"
    >
      <el-table-column
        prop="createdAt"
        align="left"
        label="挑战时间"
        :formatter="challengeAtFormtter"
        min-width="100"
      ></el-table-column>
      <el-table-column
        prop="operatorName"
        align="left"
        label="挑战类型"
        :formatter="challengeTypeFormtter"
        min-width="100"
      ></el-table-column>
      <el-table-column
        prop="operateType"
        align="left"
        label="挑战结果"
        :formatter="challengeResultFormtter"
        min-width="100"
      ></el-table-column>
    </el-table>
    <div v-else>
      <visionChallengeChart
        class="AgencyAccountTable"
        :challengeResult="visionChallengeResult"
        v-if="challengeResult.length > 0"
      />
    </div>
    <PagenationContainer v-if="pageCount > 1">
      <el-pagination
        background
        @current-change="handleCurrentChange"
        :current-page="activePage"
        :page-count="pageCount"
        layout="prev, pager, next, jumper"
      ></el-pagination>
    </PagenationContainer>
  </div>
</template>

<style lang="scss">
@import "@/css/color.scss";

.AgentDetailVisionChallenge {
  .AgencyAccountTable {
    margin: 20px 2%;
    border: 1px;
    width: 96%;
    .checkBoxLabel {
      color: #303133;
      .el-checkbox__input.is-disabled + span.el-checkbox__label {
        color: #303133;
      }
    }
    .el-table__body tr:hover > td {
      background-color: #e6f7ff !important;
      cursor: pointer;
    }

    .el-table__body tr.current-row > td {
      background-color: #e6f7ff !important;
      cursor: pointer;
    }
  }
  .TextGroup {
    display: flex;
    justify-content: space-between;
    margin: 10px 2% 0px;
    line-height: 35px;
    .dateRange {
      width: 250px;

      .el-range-editor--mini.el-input__inner {
        height: 32px;
      }

      .el-range-editor.is-active,
      .el-range-editor.is-active:hover {
        border-color: #00c1de;
      }

      .el-date-table td.today span {
        color: #00c1de;
      }
    }

    .dateSearch {
      float: left;
    }
    .switchIcon {
      cursor: pointer;
      width: 22px;
      display: inline-block;
      margin-bottom: -6px;
      margin-left: 5px;
    }
    .typeSearch {
      float: right;
      // max-width: 800px;
      // line-height: 20px;
    }
    .el-radio__input.is-checked .el-radio__inner {
      border-color: #00c1de;
      background-color: #fff;
    }

    .el-radio__inner::after {
      background-color: #00c1de;
    }

    .el-radio__input.is-checked + .el-radio__label {
      color: #00c1de;
    }
  }
}
// .paymentConfirmClass {
//   .el-message-box__content {
//     font-size: 18px;
//     color: #303133;
//   }
//   .el-button--small,
//   .el-button--small.is-round {
//     width: 90%;
//     height: 35px;
//     font-size: 14px;
//     background-color: #00c1de;
//     border-color: #00c1de;
//   }
//   border-radius: 12px;
// }
</style>





// WEBPACK FOOTER //
// src/components/patientManagement/visionChallenge.vue